import { c as _c } from "react/compiler-runtime";
import { LINK_ITEM_API, getLinkItemPostPath } from 'modules/stores/api/stores-api';
import { LinkItemUpdateType, LinkItemViewType } from 'modules/stores/store/content/link/types/link-interface';
import { usePublisherErrorHandler } from 'modules/stores/store/hooks/use-publisher-error-handler';
import { StoreId } from 'modules/stores/types/stores-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useLinkActions = () => {
  const $ = _c(15);
  const {
    internalErrorHandler
  } = usePublisherErrorHandler();
  let t0;
  if ($[0] !== internalErrorHandler) {
    t0 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp,
      internalErrorHandler
    };
    $[0] = internalErrorHandler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[2] !== internalErrorHandler) {
    t1 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp2,
      internalErrorHandler
    };
    $[2] = internalErrorHandler;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[5] !== postFetcher) {
    t3 = (storeId, data) => postFetcher(getLinkItemPostPath(storeId), data);
    $[5] = postFetcher;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const createLink = t3;
  let t4;
  if ($[7] !== putFetcher) {
    t4 = (id, data_0) => putFetcher(`${LINK_ITEM_API}/${id}`, data_0);
    $[7] = putFetcher;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const updateLink = t4;
  let t5;
  if ($[9] !== deleteFetcher) {
    t5 = id_0 => deleteFetcher(`${LINK_ITEM_API}/${id_0}`);
    $[9] = deleteFetcher;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const deleteLink = t5;
  let t6;
  if ($[11] !== createLink || $[12] !== deleteLink || $[13] !== updateLink) {
    t6 = {
      createLink,
      updateLink,
      deleteLink
    };
    $[11] = createLink;
    $[12] = deleteLink;
    $[13] = updateLink;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp() {}
function _temp2() {}